var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2527_34207)" } }, [
        _c("path", {
          attrs: {
            d: "M3.42857 4.5C3.42857 5.69347 3.9102 6.83807 4.76751 7.68198C5.62482 8.52589 6.78758 9 8 9C9.21242 9 10.3752 8.52589 11.2325 7.68198C12.0898 6.83807 12.5714 5.69347 12.5714 4.5C12.5714 3.30653 12.0898 2.16193 11.2325 1.31802C10.3752 0.474106 9.21242 0 8 0C6.78758 0 5.62482 0.474106 4.76751 1.31802C3.9102 2.16193 3.42857 3.30653 3.42857 4.5ZM6.80357 11.5383L7.46786 12.6281L6.27857 16.984L4.99286 11.8195C4.92143 11.5348 4.64286 11.3484 4.35357 11.4223C1.85357 12.0375 0 14.2664 0 16.9207C0 17.5184 0.492857 18 1.09643 18H5.80357C5.80357 18 5.80357 18 5.80714 18H6H10H10.1964C10.1964 18 10.1964 18 10.2 18H14.9036C15.5107 18 16 17.5148 16 16.9207C16 14.2664 14.1464 12.0375 11.6464 11.4223C11.3571 11.352 11.0786 11.5383 11.0071 11.8195L9.72143 16.984L8.53214 12.6281L9.19643 11.5383C9.425 11.1621 9.15 10.6875 8.70714 10.6875H8H7.29643C6.85357 10.6875 6.57857 11.1656 6.80714 11.5383H6.80357Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2527_34207" } }, [
          _c("rect", { attrs: { width: "16", height: "18", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }